// extracted by mini-css-extract-plugin
export default {"captionsContainer":"AudioCaptions_captionsContainer__gyMjO","captions":"AudioCaptions_captions__SMgjn","captionTrack":"AudioCaptions_captionTrack__Fkknu"};